module.exports = __webpack_public_path__ + "static/media/logo-pascoa.48742eac.png";